document.querySelectorAll( '.b-tabs' ).forEach( ( block ) => {

	const tabs = block.querySelectorAll( '.c-tabs-list-item' );
	if ( !tabs.length ) {

		return;

	}
	const currentButton = block.querySelector( '.c-tabs-list__current' );
	const dropdown = block.querySelector( '.c-tabs-list__buttons' );
	const tabsContainer = block.querySelector( '.c-tabs-list' );

	if ( !currentButton || !dropdown || !tabsContainer ) {

		return;

	}
	const currentButtonText = currentButton.querySelector( '.js-current' );
	if ( !currentButtonText ) {

		return;

	}



	/**
	 * Sets the custom height property of a dropdown element.
	 * Retrieves the scroll height of the dropdown element and sets the custom CSS property '--dropdown-height' with this value.
	 */
	const setDropdownHeight = () => {

		dropdown.style.removeProperty( '--dropdown-height' );
		dropdown.style.setProperty( '--dropdown-height', `${ dropdown.scrollHeight }px` );

	}

	/**
	 * Function to close the dropdown by removing 'is-active' class from the current button and dropdown element.
	 */
	const closeDropdown = () => {

		currentButton.classList.remove( 'is-active' )
		dropdown.classList.remove( 'is-active' );

	}

	/**
	 * Toggles the active tab and content tab elements based on the provided tab and contentTab elements.
	 * Removes 'c-tabs-list-item--active' class from all active tab elements within the block.
	 * Removes 'b-tabs-item--active' class from all active content tab elements within the block.
	 * Adds 'c-tabs-list-item--active' class to the specified
	 * @param {Element} tab
	 * @param {Element} contentTab
	 */
	const toggleTab = ( tab, contentTab ) => {


		block.querySelectorAll( '.c-tabs-list-item.c-tabs-list-item--active' )
			.forEach( el => el.classList.remove( 'c-tabs-list-item--active' ) );

		block.querySelectorAll( '.b-tabs-item.b-tabs-item--active' )
			.forEach( el => el.classList.remove( 'b-tabs-item--active' ) );

		tab.classList.add( 'c-tabs-list-item--active' );
		contentTab.classList.add( 'b-tabs-item--active' );
		currentButtonText.textContent = tab.textContent;

	};


	/**
	 * Handles tab click event by toggling active tab and closing dropdown.
	 *
	 * @param {Event} event - The click event on a tab element.
	 */
	const handleTabClick = ( event ) => {

		const tab = event.target.closest( '.c-tabs-list-item' );
		if ( !tab ) {

			return;

		}

		const tabIndex = tab.dataset.index;
		const tabContent = block.querySelector(
			`.b-tabs-item[data-index="${ tabIndex }"]`
		);
		if ( !tabContent ) {

			return;

		}

		if ( tab.classList.contains( 'c-tabs-list-item--active' ) ) {

			return;

		}

		if ( tabContent.dataset.index === tabIndex ) {

			toggleTab( tab, tabContent );
			closeDropdown()


		}

	};


	/**
	 * Handles the click event on a dropdown button to toggle its active state.
	 * @param {Event} event - The event object triggered by the click event.
	 */
	const handleDropdownClick = ( event ) => {

		const button = event.target.closest( '.c-tabs-list__current' );
		if ( !button ) {

			return


		}

		button.classList.toggle( 'is-active' )
		dropdown.classList.toggle( 'is-active' )

	};

	/**
	 * Handle click event on the body element to close dropdown if target is outside of the tabs container.
	 * @param {Event} e - The click event object.
	 */
	const handleBodyClick = e => {

		if ( e.target && !tabsContainer.contains( e.target ) ) {

			closeDropdown()

		}

	};

	document.addEventListener( 'DOMContentLoaded', () => {

		requestAnimationFrame( () => {

			setDropdownHeight()

		} );

	} );

	block.addEventListener( 'keydown', ( e ) => {

		if ( e.key === 'Escape' || e.key === 'Esc' ) {

			closeDropdown();

		}

	} );
	window.addEventListener( 'resize', () => {

		setDropdownHeight()

	} );


	document.body.addEventListener( 'click', handleBodyClick )
	block.addEventListener( 'click', handleTabClick );
	block.addEventListener( 'click', handleDropdownClick );

} );
